// Import style
import './style.scss';

// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

// Import dom-ready
import domReady from '@wordpress/dom-ready';

// Import components of the Archive page
import IntegrationsSearch from '@automator/features/page-integrations/archive/search';

// Import images
import './img/integrations-page-banner-background.png';

// Import components of the Single page

/**
 * Class representing the Integrations page functionality.
 * This class initializes methods of both archive and single pages.
 */
export default class Integrations {
	/**
	 * Creates an instance of the Integrations class,
	 * initializing both Archive and Single page functionalities.
	 */
	constructor() {
		new Archive();
	}
}

/**
 * Class representing the Archive page functionality.
 */
class Archive {
	/**
	 * Creates an instance of the Archive class.
	 * Checks if the current page is the integrations page and initializes IntegrationsSearch if true.
	 */
	constructor() {
		// Check if it's the integrations page
		if ( this.isIntegrationsPage ) {
			new IntegrationsSearch();
		}
	}

	/**
	 * Determines if the current page is the "Integrations" page.
	 *
	 * @return {Boolean} True if the current page is the "Integrations" page, otherwise false.
	 */
	get isIntegrationsPage() {
		return isDefined( document.getElementById( 'uap-integrations' ) );
	}
}

domReady( () => {
	new Integrations();
} );
